module.exports = __webpack_public_path__ + "static/media/SideMenu_Charges.ecff953a.svg";